<template>
  <div class="home">
    <Head :logo="logo"></Head>
    <van-form>
      <van-field v-model="idCard" label="证件号码" label-class='formTitle'  placeholder="请输入证件号码" />
      <van-field v-model="phone" label="手机号码" label-class='formTitle' placeholder="请输入手机号码" />
      <van-field v-model="paymentUnit" label="姓名" label-class='formTitle' placeholder="请输入姓名" />
      <!-- <van-field v-model="payCode" label="电子缴款码" label-class='formTitle' placeholder="请输入电子缴款码" /> -->
      <!-- <van-field v-model="bizNumber" label="业务编码" label-class='formTitle' placeholder="请输入业务编码" /> -->
    </van-form>
    <van-button round block type="info" native-type="submit" @click="toPay" class="btn">下一步</van-button>
     <PrivacyDialog person='1' @getReadState='getReadState'></PrivacyDialog>
   
    <Foot v-if="list && list.bottomMessage && list.bottomMessage.length>0" :list="list"></Foot>

    <van-dialog v-model="showDialog" title="提示" >
        <div class="notice">{{notice}}</div>
    </van-dialog>
  </div>
</template> 

<script>
import Head from "@/components/head";
import Foot from "@/components/foot";
import { Dialog } from "vant";
import {judgeVde} from "@/utils/publicJudge";
import PrivacyDialog from '@/components/dialog/privacyDialog'
import { savePrivacy } from "@/utils/common";

let Base64 = require('js-base64').Base64;

export default {
  name: "Home",
  components: {
    Head,
    Foot,
    PrivacyDialog
  },
  data() {
    return {
      showDialog:false,
      notice:'',
      logo: "",
      vde: "",
      idCard: "",
      paymentUnit: "",
      phone: "",
      payCode: "",
      bizNumber: "",
      type: 0,
      list: [],
      // 小程序的参数
      openid:'',
      isWxmp:false,//判断是否在小程序内
      mpData:{},
      isRead:false,
      details:[],
    };
  },
  created() {
    this.vde =this.$route.query.vde?this.$route.query.vde:''
    //判断vde
    this.initFrom()
    judgeVde({vde:this.vde},this)
    this.getHeadImg();
    this.getFootData();
  },
  methods: {
    // 小程序来源初始化地址
    initFrom() {
      var ua = navigator.userAgent.toLowerCase();
      if(ua.match(/MicroMessenger/i)=="micromessenger") {
          //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
          wx.miniProgram.getEnv((res)=>{
            if (res.miniprogram) {
              this.isWxmp = true
              let arr = window.location.pathname.split('/')
              let str = arr[arr.length-1]
              this.mpData = JSON.parse(Base64.decode(Base64.decode(str)))
              this.openid =this.$route.query.openid?this.$route.query.openid:''
              if (this.openid == '') {
                this.openid =this.$route.query.openId?this.$route.query.openId:''
              }
              this.mpData.params.split('&').forEach((item)=>{
                if (item.split('=')[0] == 'vde') {
                  this.vde = item.split('=')[1]
                }
              })
              window.localStorage.setItem('wxmpBack','')

            } else {
            }
          })
      }else{
      }
    },

    getHeadImg() {
      let data = {};
      data.vde = this.vde;
      this.request({
        url:'/webPortal/websitConfig',
        method:'get',
        params:data
      }).then((res)=>{
          if (res.data.code == 1000) {
            if (res.data.result.logoUrlLogin) {
              this.logo = res.data.result.logoUrlLogin;
            }else {
              this.logo = require("@/assets/img/logo.png");
          }
            document.title=res.data.result.websitTitle
            sessionStorage.setItem("title", res.data.result.websitTitle);
          } else if (res.data.code != 1000){
            this.$router.push({ path: "/404" });
          }

      })
    },
    // 获取底部数据
    getFootData() {
      let data = {
        vde: this.vde,
        type: 4
      };
      this.request({
        url:'/systemManage/mobileGetMessage',
        method:'get',
        params:data
      }).then((res)=>{
        if (res.data.code = 1000) {
          this.list = res.data.result;
        }
      })
    },
    getReadState(isRead,details) {
      this.isRead = isRead;
      this.details = details;
    },
    savePrivacy() {
      let data = {
        details:this.details,
        userId:this.paymentUnit,
        userName:this.idCard?this.idCard:this.phone?this.phone:this.paymentName,
      }
       savePrivacy(data);
    },
    toPay() {
      if (this.isRead == false) {
        Dialog.alert({
          title: "提示",
          message: "请先阅读《用户隐私政策》",
        }).then(() => {});
        return;
      }
      if (
        this.idCard == "" &&
        this.paymentUnit == "" &&
        this.phone == "" &&
        this.type == 0 &&
        this.payCode == "" &&
        this.bizNumber == ""
      ) {
        this.showDialog = true
        this.notice = '至少输入一个查询条件'
      } else if (this.phone && !/^1\d{10}$/.test(this.phone)) {
         this.showDialog = true
         this.notice = '手机号码格式不正确'
      } else if (this.paymentUnit && this.phone == "" && this.idCard == "") {
         this.showDialog = true
         this.notice = '您只输入了缴款人“姓名”查询，防止查询结果错误，请再输入一个查询条件'
      } else {
        this.savePrivacy();
        // 非小程序带的参数
        if(this.isWxmp == false) {
          this.$router.push({
            path:
              "/pages/results/results?idCard=" +
              this.idCard +
              "&paymentUnit=" +
              this.paymentUnit +
              "&phone=" +
              this.phone +
              "&type=" +
              this.type +
              "&vde=" +
              this.vde +
              "&payCode=" +
              this.payCode +
              "&bizNumber=" +
              this.bizNumber +
              "&fromtype=1"
          });
        }else if (this.isWxmp == true) {
            this.$router.push({
              path:
                "/pages/results/results?idCard=" +
                this.idCard +
                "&paymentUnit=" +
                this.paymentUnit +
                "&phone=" +
                this.phone +
                "&type=" +
                this.type +
                "&vde=" +
                this.vde +
                "&payCode=" +
                this.payCode +
                "&bizNumber=" +
                this.bizNumber +
                "&openid=" +
                this.openid +
                "&userId=" +
                this.mpData.userId +
                "&paymentName=" +
                this.mpData.paymentName +
                "&fromtype=1"
            });
        }
      }
    }
  }
};
</script>


<style lang="scss">
.home {
  padding: 0 2vw;
  box-sizing: border-box;
  .van-form {
    background: rgba(255, 255, 255, 1);
    box-shadow: 4px 4px 5px 0px rgba(51, 51, 51, 0.05);
    border-radius: 5px;
  }
  .van-cell {
    background: transparent;
  }
  .formTitle {
    padding-right: 20px;
    text-align-last: justify;
  }

  .btn {
    margin-top: 30px;
  }
}
.van-dialog__header {
    background: #1989fa;
    color: #fff;
    padding: 10px 0 !important;
    font-weight: 600 !important;
}
.notice {
  padding: 15px 10px;
  text-align: center;
  color: #646566;
}
.van-dialog__content {
  text-align: center;
  color: #646566;
  font-size: 15px;
}

</style>